import { render, staticRenderFns } from "./PlatTextLink.vue?vue&type=template&id=4406419e&scoped=true&"
import script from "./PlatTextLink.vue?vue&type=script&lang=js&"
export * from "./PlatTextLink.vue?vue&type=script&lang=js&"
import style0 from "./PlatTextLink.vue?vue&type=style&index=0&id=4406419e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4406419e",
  null
  
)

export default component.exports